// const AUTH = ["게스트", "공백", "일반", "서브관리자", "사용자관리자", "시스템관리자"]
const AUTH = ["게스트", "일반", "조교", "교수", "사용자관리자", "시스템관리자"]
export default AUTH;